<div class="leds">
  <div class="led" [ngStyle]="{'background-color': (online$ | async) ? 'yellowgreen' : 'black' }" ></div>
  <div class="led" [ngStyle]="{'background-color': (ws$ | async) ? 'orange' : 'black' }"></div>
  <div class="led" [ngStyle]="{'background-color': (http$ | async) ? 'lightcoral' : 'black' }"></div>
  <!-- <div style="background-color: lightcoral;"></div> -->
</div>